import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";

export default function CollapseMediumIcon() {
  return <ArrowDropDownRoundedIcon fontSize="medium" />;
}
